var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTypingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 6,
    viewBox: "0 0 24 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "typing-icon_svg__icon",
    d: "M2.4 5.053c1.325 0 2.4-1.131 2.4-2.527C4.8 1.131 3.725 0 2.4 0S0 1.131 0 2.526c0 1.396 1.075 2.527 2.4 2.527z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "typing-icon_svg__icon",
    d: "M12 5.053c1.325 0 2.4-1.131 2.4-2.527C14.4 1.131 13.325 0 12 0c-1.326 0-2.4 1.131-2.4 2.526 0 1.396 1.074 2.527 2.4 2.527z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "typing-icon_svg__icon",
    d: "M21.6 5.053c1.326 0 2.4-1.131 2.4-2.527C24 1.131 22.926 0 21.6 0c-1.325 0-2.4 1.131-2.4 2.526 0 1.396 1.075 2.527 2.4 2.527z",
    fill: "#838383"
  })));
}

export default __webpack_public_path__ + "./fonts/typing-icon.d394d10f940c451e45440cf3c1e19ee7.svg";
export { SvgTypingIcon as ReactComponent };